// Documentation: https://docs.rollbar.com/docs/vue-js

import Vue from 'vue'
import VueRollbar from 'vue-rollbar'
import store from './vuex'
import { DOMAIN } from './constants'

let enabled = false
let errorsNotSent = []
let globalVariablesAreSet = false

const UNKNOWN_ERROR_MESSAGE = 'Unknown Error'

const ignoredErrorMessages = [/Network error/i] // this will catch errors like "t: Network error: undefined" as they are not caught by ignoredMessages
const botsUserAgentIDs = ['Pinterestbot']
const ignoredTraceFilenames = [
  new RegExp('https://checkoutshopper-live.adyen.com/checkoutshopper/sdk/3.6.3/adyen.js'),
]

export const isErrorMessageIgnored = args =>
  Object.values(args || {}).some(error =>
    ignoredErrorMessages.some(pattern => pattern.test(error?.message))
  )

export const isBot = () =>
  botsUserAgentIDs.some(ua => (window.navigator.userAgent || '').includes(ua))

export const isTraceFilenameIgnored = (frames = []) => {
  return frames.some(({ filename = '' }) =>
    ignoredTraceFilenames.some(pattern => pattern.test(filename))
  )
}

window.addEventListener('on:global-vars-set', () => {
  globalVariablesAreSet = true
})

Vue.config.errorHandler = function (err) {
  enabled ? Vue.rollbar.error(err.message || UNKNOWN_ERROR_MESSAGE, err) : errorsNotSent.push(err)
  console.error(err) // eslint-disable-line no-console
}

Vue.use(VueRollbar, {
  accessToken: process.env.ROLLBAR_CLIENT_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled,
  environment: process.env.TARGET_ENV,
  hostWhiteList: [DOMAIN],
  ignoredMessages: [
    /Script error/i,
    /Network error/i, // this did not catch all messages (e.g. "t: Network error: undefined")
    /Network connection/i,
    /The operation was aborted/i,
  ],
  checkIgnore: (isUncaught, args = {}, payload = {}) => {
    // @see: https://docs.rollbar.com/docs/reduce-noisy-javascript-errors
    return (
      isBot() || isErrorMessageIgnored(args) || isTraceFilenameIgnored(payload.body?.trace?.frames)
    )
  },
  payload: {
    client: {
      javascript: {
        source_map_enabled: true,
        code_version: process.env.ROLLBAR_CODE_VERSION,
        // Optionally have Rollbar guess which frames the error was thrown from
        // when the browser does not provide line and column numbers.
        guess_uncaught_frames: true,
      },
    },
  },
})

function enableVueRollbar(checkIgnore) {
  enabled = true
  const config = { enabled }
  if (checkIgnore) config.checkIgnore = checkIgnore
  Vue.rollbar.configure(config)

  const configurePersonId = () => {
    Vue.rollbar.configure({
      payload: {
        person: {
          id: window.USER_ACCOUNT_DATA.id,
        },
      },
    })
  }
  globalVariablesAreSet
    ? configurePersonId()
    : window.addEventListener('on:global-vars-set', configurePersonId)

  store.watch(
    () => store.getters['account/currentUser'],
    currentUser => {
      if (!currentUser) return

      Vue.rollbar.configure({
        payload: {
          person: {
            id: currentUser.id,
            email: currentUser.email,
          },
        },
      })
    },
    {
      immediate: true,
    }
  )
  errorsNotSent.forEach(err => Vue.rollbar.error(err.message || UNKNOWN_ERROR_MESSAGE, err))
  errorsNotSent = []
}

On.enableVueRollbar = enableVueRollbar
